import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import StoryViewer from '../components/StoryViewer';
import '../styles/IssueDetail.css';
import ReviewItem from './ReviewItem';

const IssueDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const [currentIssue, setCurrentIssue] = useState(null);
  const [selectedStory, setSelectedStory] = useState(null);
  const [viewMode, setViewMode] = useState('story');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const docRef = doc(db, 'issues', `issue_${id}`);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setCurrentIssue(data);
        const mode = location.state?.mode || 'story';
        setViewMode(mode);
        // 첫 번째 소설 자동 선택
        if (data.content?.length > 0) setSelectedStory(data.content[0]);
      }
      setLoading(false);
    };
    fetchData();
  }, [id, location.state]);

  if (loading) return <div className="loading-state"> 불러오는 중...</div>;
  if (!currentIssue) return null;

  return (
    <div className="issue-detail-page">
      {/* 1. 디자인 가이드 반영: 상단 그린 헤더 */}
      <header className="issue-header-banner">
        <div className="header-inner">
          <h1 className="header-issue-title">
            {id}호 《{currentIssue.title}》
          </h1>

          <nav className="header-author-list">
            {currentIssue.content?.map((story) => (
              <span
                key={story.id}
                className={`header-author-item ${selectedStory?.id === story.id && viewMode === 'story' ? 'active' : ''}`}
                onClick={() => {
                  setSelectedStory(story);
                  setViewMode('story');
                }}
              >
                {story.author} &lt;{story.title}&gt;
              </span>
            ))}
          </nav>

          <div className="header-review-link">
            <button
              className={`review-btn ${viewMode === 'review' ? 'active' : ''}`}
              onClick={() => setViewMode('review')}
            >
              독자 후기 게시판
            </button>
          </div>
        </div>
      </header>

      {/* 2. 본문 영역 */}
      <main className="issue-content-area">
        {viewMode === 'story' ? <StoryViewer story={selectedStory} /> : <ReviewItem />}
      </main>
    </div>
  );
};

export default IssueDetail;
